/* Landing etiope — JS extraido de 'Aceite Etiope de Semilla Negra/index.html'.
   Cargado por layout/landing.liquid (case 'etiope'). */

/* countdown 24h rodante */
(function(){
  var end = new Date(); end.setHours(23,59,59,999);
  function tick(){
    var d = Math.max(0, end - new Date());
    var h = Math.floor(d/36e5), m = Math.floor(d%36e5/6e4), s = Math.floor(d%6e4/1e3);
    document.getElementById('cd-h').textContent = String(h).padStart(2,'0');
    document.getElementById('cd-m').textContent = String(m).padStart(2,'0');
    document.getElementById('cd-s').textContent = String(s).padStart(2,'0');
  }
  tick(); setInterval(tick,1000);
})();

/* galería del hero */
(function(){
  var slides = document.querySelectorAll('#gal img');
  var thumbs = document.querySelectorAll('#thumbs button');
  thumbs.forEach(function(b,i){
    b.addEventListener('click',function(){
      slides.forEach(function(s){s.classList.remove('on')});
      thumbs.forEach(function(t){t.classList.remove('on')});
      slides[i].classList.add('on'); b.classList.add('on');
    });
  });
})();

/* flechas de los thumbs */
(function(){
  var rail=document.getElementById('thumbs'); if(!rail) return;
  var i=0, per=5, total=rail.children.length;
  function draw(){ rail.style.transform='translateX(calc(-'+(i*100/per)+'% - '+(i*8/per)+'px))'; }
  rail.style.transition='transform .3s';
  document.getElementById('th-prev').onclick=function(){ i=Math.max(0,i-1); draw(); };
  document.getElementById('th-next').onclick=function(){ i=Math.min(total-per,i+1); draw(); };
})();

/* carrusel de reseñas: flechas + dots */
(function(){
  var rail=document.getElementById('revRail'); if(!rail) return;
  var dots=[].slice.call(document.querySelectorAll('#revDots i'));
  var card=rail.querySelector('.rev');
  function step(){ return card.getBoundingClientRect().width+18; }
  document.getElementById('rev-prev').onclick=function(){ rail.scrollBy({left:-step()*2,behavior:'smooth'}); };
  document.getElementById('rev-next').onclick=function(){ rail.scrollBy({left:step()*2,behavior:'smooth'}); };
  rail.addEventListener('scroll',function(){
    var k=Math.round(rail.scrollLeft/step());
    dots.forEach(function(d,n){ d.classList.toggle('on',n===Math.min(k,dots.length-1)); });
  });
})();

/* dots de ingredientes */
(function(){
  var rail=document.getElementById('ingRail'); if(!rail) return;
  var dots=[].slice.call(document.querySelectorAll('#ingDots i'));
  rail.addEventListener('scroll',function(){
    var k=Math.round(rail.scrollLeft/(rail.scrollWidth/dots.length));
    dots.forEach(function(d,n){ d.classList.toggle('on',n===Math.min(k,dots.length-1)); });
  });
})();

/* línea de tiempo: se dibuja y revela con el scroll */
(function(){
  var tl=document.querySelector('.tl'); if(!tl) return;
  var fill=document.createElement('i'); fill.className='tl-fill'; tl.appendChild(fill);
  var rows=[].slice.call(tl.querySelectorAll('.tl-row'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.4,rootMargin:'0px 0px -10% 0px'});
    rows.forEach(function(r){ io.observe(r); });
  } else { rows.forEach(function(r){ r.classList.add('in'); }); }
  function draw(){
    var r=tl.getBoundingClientRect();
    var p=(innerHeight*0.78 - r.top)/r.height;
    p=Math.max(0,Math.min(1,p));
    fill.style.height=(p*100).toFixed(2)+'%';
    rows.forEach(function(row){
      if(!row.classList.contains('in') && row.getBoundingClientRect().top < innerHeight*0.80){ row.classList.add('in'); }
    });
  }
  addEventListener('scroll',draw,{passive:true}); addEventListener('resize',draw);
  addEventListener('load',draw); addEventListener('hashchange',function(){ requestAnimationFrame(draw); });
  draw(); requestAnimationFrame(draw);
})();

/* selector de bundles */
(function(){
  var cards = document.querySelectorAll('#bundles .bd');
  cards.forEach(function(c){
    c.addEventListener('click',function(){
      cards.forEach(function(x){x.classList.remove('on')});
      c.classList.add('on');
    });
  });
})();

/* ============================================================
   Bundle activo → variante + cantidad + trigger del modal Releasit COD
   Cada tier es una variante real con precio POR UNIDAD y el SKU de Dropi
   (65985). Se manda quantity = N para que unit_price x N = total del bundle
   y el pedido lleve las unidades fisicas reales a Dropi.
   NO usar _rsiV2.setState como primer path: abre el modal con la variante
   cacheada al init. Solo el click nativo del boton Releasit re-lee
   window.productData. Ver memory/project_releasit_cod_pattern.
   ============================================================ */
(function () {
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  var selectedVariantId = null;
  var selectedQty = 1;

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="product-id"]').forEach(function (i) { i.value = variantId; });
    document.querySelectorAll('input[name="quantity"]').forEach(function (i) {
      i.value = String(q);
      i.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function syncFromDom() {
    var card = document.querySelector('.etiope-landing #bundles .bd.on')
            || document.querySelector('.etiope-landing #bundles .bd');
    if (!card) return;
    var id = card.getAttribute('data-bundle-variant-id');
    var q = parseInt(card.getAttribute('data-bundle-qty'), 10) || 1;
    if (!id) return;
    selectedVariantId = id;
    selectedQty = q;
    setVariantOnAllForms(id, q);
  }

  // el selector de bundles de arriba ya mueve la clase .on; aqui solo re-leemos el DOM
  document.querySelectorAll('.etiope-landing #bundles .bd').forEach(function (el) {
    el.addEventListener('click', function () { setTimeout(syncFromDom, 0); });
  });

  syncFromDom();

  window.etiopeTriggerCOD = function () {
    syncFromDom();
    if (selectedVariantId) setVariantOnAllForms(selectedVariantId, selectedQty);
    setTimeout(function () {
      var b0 = findReleasitButton();
      if (b0) { b0.click(); return; }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var b = findReleasitButton();
        if (b) { clearInterval(poll); b.click(); return; }
        if (attempts > 30) {
          clearInterval(poll);
          if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
            try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
          }
        }
      }, 100);
    }, 50);
  };
})();
